module.exports = __webpack_public_path__ + "static/media/h1z1.6057db20.jpg";